import React from "react";
import { Helmet } from "react-helmet-async";
import i18n from "../../i18n";

export default function ReusableHelmet({
  section,
  tabTitle,
  description,
  pageTitle,
  socialImage,
  canonicalPath,
  noIndex = false,
  jsonLd,
}) {
  const baseUrl = "https://tenders.club";
  const langCode = i18n.language.slice(0, 2);
  const canonicalUrl = canonicalPath ? `${baseUrl}/${langCode}${canonicalPath}` : undefined;

  return (
    <Helmet>
      <title>{`${section} | ${tabTitle}`}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      {socialImage && <meta property="og:image" content={socialImage} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <html lang={langCode} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
